// util for creating unique id's for components (Currently used only by ComposableTabs)
export class ComponentIdProducer {
  private static numberId = 0;
  private static testMode = process.env.JEST_WORKER_ID !== undefined;

  static createStaticProducer({
    prefix = 'telia-component',
    testMode = ComponentIdProducer.testMode,
  }) {
    return function createComponentId() {
      if (testMode) {
        return `${prefix}-${ComponentIdProducer.numberId}`;
      }
      return `${prefix}-${ComponentIdProducer.numberId++}`;
    };
  }

  // Only call this method in ComponentIdProducer tests
  static resetStaticProducer() {
    ComponentIdProducer.numberId = 0;
  }
}
